export default "<p>bsngx-model works!</p>\n"